import AllFilters from 'filters/all-filters';
import CompanyAlerts from 'alerts/company-alerts';
import {setUpgradeSkillsInclusion} from 'sales/upgrade';

window.explore = function () {
    let suggestedRticsDropdown, suggestedCicsDropdown;
    let userHasCicLists = false;

    async function pageBodyLoad() {
        exploreLists.showSpinner();
        checkUserStatus();
        setDownloadOverlayCheckIfFinancialFieldEvent();

        await companyAlerts.getCompanyAlertData();
    }

    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            getUserStatusLoad(JSON.parse(response));
        }

        const checkUserStatusError = function () {
            var response = {
                "logged_in": false,
                "message": "Could not check user status"
            }
            getUserStatusLoad(response);
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    function getUserStatusLoad(response) {
        // Valid user
        if (response.logged_in == true) {
            coreFunctions.userguidingSetup(response);
            // setPopStateEvent();
            // TODO Look at this
            exploreLists.filters.getAllFilters(pageLoadComplete);
        } else {
            requireLogin();
            return;
        }

        const userHasRSICLists = response.user_details.premiumFeatures.includes("rsics");
        if (!userHasRSICLists) {
            exploreLists.filters.upgradableFilter("RSICs", "rsics_filter");
        }

        setUpgradeSkillsInclusion();
    }

    // Set event for when back button is pressed
    function setPopStateEvent() {
        window.onpopstate = function (event) {
            var pageNumber = getQueryVariable("page");
            if (pageNumber) {
                filterCompanies(pageNumber);
            }
        };
    }

    function setDownloadOverlayCheckIfFinancialFieldEvent() {
        document.querySelectorAll('#downloadFields input[name="downloadFields[]"]').forEach(input => {
            input.addEventListener("change", () => {
                if (input.hasAttribute('data-financial-field')) {
                    document.querySelector('#downloadSelection input[name="downloadFields[]"][value="Yearending"]').checked = true;
                }
                if(document.querySelectorAll('#downloadFields input[name="downloadFields[]"][data-financial-field]:checked').length == 0) {
                    document.querySelector('#downloadSelection input[name="downloadFields[]"][value="Yearending"]').checked = false;
                }
            });
        });
    }

    function pageLoadComplete() {
        exploreLists.checkForPreloadedList();

        // Create report RTICs dropdown options
        const rticsSearchOptions = {
            create: false,
            sortField: [
                {
                    field: "optgroup",
                    direction: "asc"
                }, {
                    field: "text",
                    direction: "asc"
                }
            ],
            onItemAdd: (value) => coreFunctions.refreshFormFieldErrors(document.getElementById("reportMismatchedRticForm")),
            optgroupValueField: "label",
            searchField: [
                { field: "text", direction: "asc" },
                { field: "optgroup", direction: "asc" }
            ],
            plugins: {
                'checkbox_options': {
                    'checkedClassNames':   ['ts-checked'],
                    'uncheckedClassNames': ['ts-unchecked'],
                },
                'no_backspace_delete': {},
                'remove_button': {}
            },
            maxOptions: null,
            render: {
                optgroup_header: function(data, escape) {
                    return '<div class="optgroup-header">' + escape(data.label) + '</div>';
                },
                option: function(data, escape) {
                    return '<div class="suggested-rtic-option">' + escape(data.text) + '</div>';
                },
                item: function(data, escape) {
                    return '<div class="report-rtic-item suggested-rtic-item"><div>' + escape(data.text) + '<br><div class="sector">'+ escape(data.sector) + '</div></div>';
                }
            }
        }

        userHasCicLists = document.querySelector("#suggestCompanyCicsSelect option") != undefined;
        exploreLists.filters.rticFilters.populateSuggestedRticsDropdown();
        suggestedRticsDropdown = new TomSelect("#suggestCompanyRticsSelect", rticsSearchOptions);
        suggestedCicsDropdown = new TomSelect("#suggestCompanyCicsSelect", rticsSearchOptions);
        setDownloadOverlayCheckIfFinancialFieldEvent();
    }

    function clearSuggestedRticsDropdown() {
        suggestedRticsDropdown.clear();
    }

    function clearSuggestedCicsDropdown() {
        suggestedCicsDropdown.clear();
    }

    class ExploreLists {
        exploreLists;
        prefilterCode;
        prefilterName;
        constructor() {
            this.activeExploreListID = null;
            this.activeExploreListName = "All UK Companies";
            this.activeExploreListNotes = "";
            this.orderResultsBy = "SectorKeywordCount";
            this.orderResults = "desc";
            this.filters = new AllFilters("explore");
            this.results = new ExploreListResults(this);
            this.filterByCompanyNumberNameUrlOnly = false;
        }

        getExploreLists() {
            if (!this.exploreLists) {
                let method, url;
                const exploreListsObject = this;

                method = "POST";
                url = `../api/lists/lists_actions.php?action=getexplorelists`;

                const getExploreListsSuccess = (responseText) => {
                    const response = JSON.parse(responseText);
                    if (response.status == "success") {
                        this.exploreLists = [];
                        response.exploreLists.forEach(list => exploreListsObject.newExploreList(list.listID, list.listName, list.notes, list.listCreated, list.listEdited));
                        this.setLoadExploreListDefault();
                    }
                }

                const getExploreListsError = function () {
                    console.log("Error obtaining explore lists");
                }

                coreFunctions.xhrHelper(method, url, getExploreListsSuccess, getExploreListsError);
            }
        }

        formatPrefilterTitle() {
            return this.prefilterName.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()) + ` (${this.prefilterCode})`;
        }

        checkForPreloadedList() {
            let queryString, rticSector, rticVertical;
            if (queryString = coreFunctions.getQueryVariable("rtic")) {
                rticSector = decodeURIComponent(queryString);
                rticVertical = (coreFunctions.getQueryVariable("vertical") ? decodeURIComponent(coreFunctions.getQueryVariable("vertical")) : null);
                this.activeExploreListName = this.filters.rticFilters.formatPreloadedRticName(rticSector, rticVertical);
                this.filters.rticFilters.preloadRticSector(rticSector, rticVertical);
                this.filteringStarted().displaySavePlusExplanationControl().filterCompanies();
            }
            // Load a previously saved list
            else if (queryString = coreFunctions.getQueryVariable("list_id")) {
                this.preloadExploreList(queryString);
            }
            // Search for individual company
            else if (queryString = coreFunctions.getQueryVariable("searchstring")) {
                this.preloadSearchByCompanyNumberNameUrl(queryString);
            }
            else if (queryString = coreFunctions.getQueryVariable("prefilter")) {
                this.prefilterCode = queryString;
                this.prefilterName = coreFunctions.getQueryVariable("prefilter_name") ? decodeURIComponent(coreFunctions.getQueryVariable("prefilter_name")) : '';
                this.filters.processStoredGeneralFilters({SelectedISCodes: [this.prefilterCode] }); // Preset IS Codes filter
                this.activeExploreListName = this.formatPrefilterTitle();
                this.loadingComplete();
            } else {
                this.loadingComplete();
            }

            return this;
        }

        loadingComplete() {
            this.updateSortByFieldBasedOnFilters().filteringStarted().filterCompanies();
            updatePageTitle();
        }

        newExploreList(listID, name, notes, created, edited) {
            const exploreList = new ExploreList(listID, name, notes, created, edited).addListElementToLoadExploreList();
            if (this.exploreLists == undefined) {
                this.exploreLists = [];
            }
            this.exploreLists.push(exploreList);
            return exploreList;
        }

        preloadSearchByCompanyNumberNameUrl(companyQuery) {
            const filtersObject = {
                filters: {
                    CompanyName: decodeURI(companyQuery)
                }
            };
            this.filters.processAllStoredFilters(filtersObject);
            this.filterCompaniesByNumberNameUrl();
            return this;
        }

        getFiltersForCompaniesNumberNameUrlSearch() {
            let filtersObject = {
                OrderBy: 'SearchMatch',
                Order: 'desc',
                filters: {
                    OrderBy: 'SearchMatch',
                    Order: 'desc',
                    Skip: 0,
                    CompanyName: document.getElementById("companyNumberNameUrlInput").value.trim()
                }
            }
            Object.assign(filtersObject.filters, this.filters.rticFilters.getUserCics());
            return filtersObject;
        }

        filterCompaniesByNumberNameUrl() {
            let method, url;
            const exploreListsObject = this;
            const input = this.getFiltersForCompaniesNumberNameUrlSearch();
            this.filterByCompanyNumberNameUrlOnly = true;

            method = "POST";
            url = `../api/explore/explore_actions.php?action=filtercompanies&listid=${this.activeExploreListID}`;

            const filterCompaniesSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                coreFunctions.checkForDebugMessages(response);
                exploreListsObject.filteringComplete();
                exploreListsObject.results.processResults(response.results).formatPageNumbers().addCompaniesToPage();
                exploreListsObject.updateAnalysePageLink();
            }

            const filterCompaniesError = function () {
                console.log("Error filtering explore lists");
                exploreListsObject.filteringComplete();
            }

            coreFunctions.xhrHelper(method, url, filterCompaniesSuccess, filterCompaniesError, JSON.stringify(input));
        }

        filterCompanies() {
            let method, url;
            const exploreListsObject = this;
            const input = {
                OrderBy: this.orderResultsBy,
                Order: this.orderResults
            }
            const filtersForSearch = this.filters.getFiltersForSearch();
            this.filterByCompanyNumberNameUrlOnly = false;

            Object.assign(input, filtersForSearch);
            Object.assign(input, this.prefilterCode ? {'prefilterCode': this.prefilterCode} : false);
            Object.assign(input.filters, {Skip: (exploreLists.results.pageNumber - 1) * exploreLists.results.companiesPerPage});

            method = "POST";
            url = `../api/explore/explore_actions.php?action=filtercompanies&listid=${this.activeExploreListID}`;

            const filterCompaniesSuccess = (responseText) => {
                const response = JSON.parse(responseText);
                coreFunctions.checkForDebugMessages(response);
                exploreListsObject.filteringComplete().updateListFiltersDescription();
                exploreListsObject.results.processResults(response.results).formatPageNumbers().addCompaniesToPage()
                this.filters.saveFiltersState(this.filters.getFiltersForSavedList());
                exploreListsObject.updateAnalysePageLink();
                updatePageTitle();
            }

            const filterCompaniesError = function () {
                console.log("Error filtering explore lists");
                exploreListsObject.filteringComplete();
            }

            coreFunctions.xhrHelper(method, url, filterCompaniesSuccess, filterCompaniesError, JSON.stringify(input));
        }

        getCompaniesUrls() {
            let method, url;
            const exploreListsObject = this;
            const input = {
                OrderBy: this.orderResultsBy,
                Order: this.orderResults
            }
            Object.assign(input, this.filters.getFiltersForSearch());

            method = "POST";
            url = `../api/explore/explore_actions.php?action=geturls&listid=${this.activeExploreListID}`;

            const getCompaniesUrlsSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                coreFunctions.checkForDebugMessages(response);
                exploreListsObject.copyCompanyUrlsToClipboard(response);
            }

            const getCompaniesUrlsError = function () {
                console.log("Error getting company URLs");
            }

            coreFunctions.xhrHelper(method, url, getCompaniesUrlsSuccess, getCompaniesUrlsError, JSON.stringify(input));
        }

        copyCompanyUrlsToClipboard(response) {
            let companyUrlsInput = response.results;
            if (companyUrlsInput.length > 0) {
                navigator.clipboard.writeText(companyUrlsInput.join('\n')).then(function() {
                    coreFunctions.showOverlay("copytohunter");
                }, function() {
                    console.log("clipboard write failed");
                });
            }
        }

        sortByFieldChange() {
            this.results.pageNumber = 1;
            this.orderResultsBy = document.getElementById("sortByField").options[document.getElementById("sortByField").selectedIndex].getAttribute("name");
            this.orderResults = document.getElementById("sortByField").options[document.getElementById("sortByField").selectedIndex].dataset.sort;
            return this;
        }

        updateSortByFieldBasedOnFilters() {
            const keywordFilterIsActive = this.filters.keywordFilters.keywordFilteringActive();
            this.updateSortByFieldBasedOnFilter("descKeywords", keywordFilterIsActive);

            const companyNameFilterIsActive = this.filters.companyFilters.companyNameFilterIsActive();
            this.updateSortByFieldBasedOnFilter("ascSearchMatch", companyNameFilterIsActive);

            this.sortByFieldChange();
            return this;
        }

        updateSortByFieldBasedOnFilter(value, filterIsActive) {
            const select = document.getElementById("sortByField");
            const option = select.querySelector(`option[value='${value}']`);
            if (filterIsActive) {
                select.value = value;
                option.disabled = false;
            } else {
                if (select.value == value) this.updateSortByFieldToDefaultOption();
                option.disabled = true;
            }
            return this;
        }

        updateSortByFieldToDefaultOption() {
            document.getElementById("sortByField").value = "descSectorKeywordCount";
            return this;
        }

        updateSortByFieldBasedOnKeywords() {
            if (this.filters.keywordFilters.keywordFilteringActive()) {
                document.getElementById("sortByField").value = "descKeywords";
                document.querySelector("#sortByField option[name='Keywords']").disabled = false;
            } else {
                if (document.getElementById("sortByField").value == "descKeywords") {
                    this.updateSortByFieldToDefaultOption();
                }
                document.querySelector("#sortByField option[name='Keywords']").disabled = true;
            }
            // this.sortByFieldChange();
            return this;
        }

        updateSortByFieldBasedOnCompanyNameFilter() {
            if (this.filters.companyFilters.companyNameFilterIsActive()) {
                document.getElementById("sortByField").value = "ascSearchMatch";
                document.querySelector("#sortByField option[name='SearchMatch']").disabled = false;
            } else {
                if (document.getElementById("sortByField").value == "ascSearchMatch") {
                    this.updateSortByFieldToDefaultOption();
                }
                document.querySelector("#sortByField option[name='SearchMatch']").disabled = true;
            }
            return this;
        }

        updateAnalysePageLink() {
            let url;
            // Current list has been saved, can be loaded directly from the analyse page
            if (this.activeExploreListID) {
                url = `${urlPath}/analyse?explorelist_id=${this.activeExploreListID}`;
            }
            // List unsaved, send current filters only
            else {
                url = `${urlPath}/analyse?list_id=All&filters_code=${this.filters.storedFiltersCode}${(coreFunctions.getQueryVariable("rtic")) ? (`&rtic=${coreFunctions.getQueryVariable("rtic")}`) : ""}`;
            }
            if (this.prefilterCode) {
                url += `&prefilter=${this.prefilterCode}&prefilter_name=${this.prefilterName}`;
            }
            document.getElementById("insightsLink").href =
            document.getElementById("insightsLinkHeader").href = url;
            // Only show analysis link if filters have been updated
            if (document.getElementById("savePlusExplanationControl").classList.contains("visible")) {
                document.getElementById("insightsLinkHeader").classList.add("visible");
            }
            return this;
        }

        // Filtering in progress, animation for spinner
        filteringInProgress() {
            if (document.getElementById("spinner").classList.contains("spinnerVisible") == false) {
                this.filteringStarted();
                setTimeout(function () {
                    this.filteringComplete();
                }, 1000);
            }
        }

        // Filtering in progress
        filteringStarted() {
            // Hide the active filter control elements
            this.filters.hideFilterControls();
            this.showSpinner();
            this.checkPrefilterStatus();
            // Update filter button appearance
            document.getElementById("exploreListName").innerHTML = this.activeExploreListName;
            document.getElementById("editExploreListNotes").innerHTML = this.activeExploreListNotes;
            this.updateListNotes();
            document.querySelector("#updateFiltersButton span").innerHTML = "Updating...";
            document.getElementById("filtersHeader").classList.add("filterDisabled");

            return this;
        }

        // If using prefilter, check to see if it is still active
        checkPrefilterStatus() {
            if (this.prefilterCode) {
                const flattenedFilters = this.filters.getFlattenedFilters();
                // Filters no longer include original prefilter code
                if (!flattenedFilters.includes(this.prefilterCode)) {
                    this.resetPrefilter();
                }
            }
            return this;
        }

        resetPrefilter() {
            // Reset fields
            this.prefilterCode = null;
            this.prefilterName = null;
            this.activeExploreListName = "All UK Companies";

            // Remove prefilter search params from URL
            const urlParamsString = window.location.search;
            const urlSearchParams = new URLSearchParams(urlParamsString);
            urlSearchParams.delete("prefilter_name");
            urlSearchParams.delete("prefilter");
            window.history.replaceState('searchquery', 'searchqueryedit', urlSearchParams.toString());
        }

        displaySavePlusExplanationControl() {
            document.getElementById("savePlusExplanationControl").classList.add("visible");
            return this;
        }

        hideSavePlusExplanationControl() {
            document.getElementById("savePlusExplanationControl").classList.remove("visible");
            return this;
        }

        showSpinner() {
            let spinner = document.getElementById("spinner");
            spinner.classList.add("spinnerVisible");
            spinnerHolder.classList.add("active");
            spinner.style.display = "block";
            setTimeout(function () {
                spinner.style.opacity = "1";
            }, 100);
            return this;
        }

        hideSpinner() {
            let spinner = document.getElementById("spinner");
            spinner.style.opacity = "0";
            spinnerHolder.classList.remove("active");
            spinner.style.display = "none";
            spinner.classList.remove("spinnerVisible");
            return this;
        }

        // Filtering complete
        filteringComplete() {
            main.classList.remove("mainHidden");
            this.hideSpinner();
            setTimeout(function () {
                document.querySelector("#updateFiltersButton span").innerHTML = "Update";
                document.getElementById("filtersHeader").classList.remove("filterDisabled");
            }, 400);
            return this;
        }

        updateListFiltersDescription() {
            if (document.getElementById("listFiltersDescription")) {
                document.getElementById("listFiltersDescription").innerHTML = this.filters.getHumanReadableFiltersRepresentation();
            }
            return this;
        }

        enableExploreListControls() {
            document.querySelector(".listActionsControlLabel .controls").classList.remove("currentListUnsaved");
            return this;
        }

        disableExploreListControls() {
            document.querySelector(".listActionsControlLabel .controls").classList.add("currentListUnsaved");
            return this;
        }

        resetExplorePage() {
            this.activeExploreListID = null;
            this.activeExploreListName = "All UK Companies";
            this.hideSavePlusExplanationControl().disableExploreListControls().filteringStarted();
            this.filters.resetAllFilters();
            this.filterCompanies();
            return this;
        }

        updateEditExploreListOverlay() {
            // Hide previous input errors
            exploreLists.clearEditExploreListInputError();
            document.querySelector("#editExploreListForm input[name='listID']").value = this.activeExploreListID;
            document.querySelector("#editExploreListForm input[name='listName']").value =  this.activeExploreListName;
            coreFunctions.showOverlay("editexplorelist");
        }

        editExploreList(form) {
            let input, method, url;
            const exploreListsObject = this;

            document.getElementById("editExploreListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=edit&listid=${this.activeExploreListID}`;

            const editExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    exploreListsObject.exploreLists.find(list => list.listID == response.listID).editExploreListLoad(response);
                } else {
                    exploreListsObject.editListError(response);
                }
            }

            const editExploreListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit explore list."
                }
                exploreListsObject.editListError(response);
            }

            coreFunctions.xhrHelper(method, url, editExploreListSuccess, editExploreListError, input);
        }

        editListError(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#editListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("editListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearEditExploreListInputError() {
            document.querySelector("#editExploreListForm .input_error").innerHTML = "&nbsp;";
        }

        saveExploreListTitleChange(element) {
            if (element.value == element.dataset.existingname) {
                document.querySelector("#saveExploreListForm input[name='listID']").value = this.activeExploreListID;
            } else {
                document.querySelector("#saveExploreListForm input[name='listID']").value = null;
            }
        }

        updateNotesExploreListOverlay() {
            // Hide previous input errors
            exploreLists.clearNotesExploreListInputError();
            document.querySelector("#notesExploreListForm input[name='listID']").value = this.activeExploreListID;
            coreFunctions.showOverlay("notesexplorelist");
        }

        updateListNotes() {
            document.getElementById("listNotes").innerHTML = this.activeExploreListNotes;
            document.getElementById("listNotes").classList.toggle("hidden", !this.activeExploreListNotes || this.activeExploreListNotes.length == 0);
            return this;
        }

        editExploreListNotes(form) {
            let input, method, url;
            const exploreListsObject = this;

            document.getElementById("notesExploreListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=notes&listid=${this.activeExploreListID}`;

            const notesExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    document.getElementById("notesExploreListSubmitButton").disabled = false;

                    // Update the notes with the filtered response
                    document.querySelector("#notesExploreListForm textarea[name='notes']").value = response.notes;
                    exploreListsObject.activeExploreListNotes = response.notes;
                    exploreListsObject.updateListNotes();

                    // Hide form and display success message
                    coreFunctions.hideOverlay(document.getElementById("notesExploreListForm"));
                    coreFunctions.showStatusMessage(response.title, response.message);
                } else {
                    exploreListsObject.editListError(response);
                }
            }

            const notesExploreListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit explore list."
                }
                exploreListsObject.editListNotesError(response);
            }

            coreFunctions.xhrHelper(method, url, notesExploreListSuccess, notesExploreListError, input);
        }

        editListNotesError(response) {
            // Remove in progress class from button
            document.getElementById("notesExploreListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#notesExploreListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("notesExploreListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearNotesExploreListInputError() {
            document.querySelector("#notesExploreListForm .input_error").innerHTML = "&nbsp;";
        }

        copyExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("copyExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=copy&listid=${this.activeExploreListID}`;


            const copyExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.copyExploreListLoad(response);
            }

            const copyExploreListError = function () {
                const response = {
                    status: "error",
                    title: "List copy error",
                    message: "Sorry, your list could not be copied at this time."
                }
                listsObject.copyExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, copyExploreListSuccess, copyExploreListError, input);

        }

        copyExploreListLoad(response) {
            document.getElementById("copyExploreListButton").disabled = false;
            if (response.status == "success") {
                this.newExploreList(response.listID, response.listName, '', response.listCreated, response.listEdited).addListElementToPage(true);
            }
            coreFunctions.hideOverlay(document.getElementById("copyExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        deleteExploreListButtonClick() {
            document.getElementById("exploreListDeleteWarningTitle").innerHTML = `Confirm "${this.activeExploreListName}" deletion`;
            document.querySelector("#deleteExploreListForm input[name='listID']").value = this.activeExploreListID;
            document.querySelector("#deleteExploreListForm input[name='name']").value = this.activeExploreListName;
            coreFunctions.showOverlay("deleteexplorelistpanel");
        }

        deleteExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("deleteExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=delete&listid=${this.activeExploreListID}`;

            const deleteExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.deleteExploreListLoad(response);
            }

            const deleteExploreListError = function () {
                const response = {
                    status: "error",
                    "title": "Error",
                    "message": "Sorry, could not delete Explore list."
                }
                listsObject.deleteExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, deleteExploreListSuccess, deleteExploreListError, input);

        }

        deleteExploreListLoad(response) {
            document.getElementById("deleteExploreListButton").disabled = false;
            if (response.status == "success") {
                this.exploreLists.find(list => list.listID == response.listID).removeListElementFromLoadExploreList();
            }
            coreFunctions.hideOverlay(document.getElementById("deleteExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
            this.resetExplorePage();
        }

        shareListButtonClick() {
            document.querySelector("#shareExploreListForm input[name='listID']").value = this.activeExploreListID;
            document.querySelector("#shareExploreListForm input[name='listName']").value = this.activeExploreListName;
            this.resetShareExploreListInputErrors();
            coreFunctions.showOverlay("shareexplorelist");
        }

        shareExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("shareExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=share&listid=${this.activeExploreListID}`;

            const shareExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.shareExploreListLoad(response);
            }

            const shareExploreListError = function () {
                const response = {
                    status: "error",
                    input_errors: {
                        email: "&nbsp;",
                        general: "Could not share list. An unexpected error occurred. Please try again."
                    }
                }
                listsObject.shareExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, shareExploreListSuccess, shareExploreListError, input);
        }

        // Clear input errors
        resetShareExploreListInputErrors() {
            document.querySelector("#shareExploreListForm .input_error[field='email']").innerHTML = "&nbsp;";
            document.querySelector("#shareExploreListForm .input_error[field='general']").innerHTML = "&nbsp;";
        }

        shareExploreListLoad(response) {
            document.getElementById("shareExploreListButton").disabled = false;
            if (response.status == "success") {
                coreFunctions.hideOverlay(document.getElementById("shareExploreListButton"));
                showStatusMessage(response.title, response.message);
            } else {
                document.querySelector("#shareExploreListForm .input_error[field='email']").innerHTML = (response.input_errors.email) ? response.input_errors.email : "&nbsp;";
                document.querySelector("#shareExploreListForm .input_error[field='general']").innerHTML = (response.input_errors.general) ? response.input_errors.general : "&nbsp;";
            }
        }

        // Report missing or mismatched URL
        reportUrl(form) {
            // Request options
            let method, url, input, reportUrlSuccess, reportUrlError;
            method = "POST";
            url = `../api/company/company_actions.php?action=reporturl&company_number=${document.querySelector("#reportMismatchedUrlForm input[name='companyNumber']").value}`;
            input = new FormData(form);

            // Success
            reportUrlSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                if (responseParsed && responseParsed.status == "success") {
                    document.querySelector(`.report_mismatched_url[data-companynumber='${responseParsed.company_number}']`).disabled = true;
                }
                coreFunctions.showStatusMessage(responseParsed.title, responseParsed.message);
                coreFunctions.hideOverlay(document.getElementById("reportMismatchedUrlButton"));
            }

            // Error
            reportUrlError = function () {
                const response = {
                    status: "error",
                    title: "Submission error",
                    message: "Sorry, we could not submit your request at this time."
                }
                coreFunctions.showStatusMessage(response.title, response.message);
                coreFunctions.hideOverlay(document.getElementById("reportMismatchedUrlButton"));
            }

            coreFunctions.xhrHelper(method, url, reportUrlSuccess, reportUrlError, input);
        }

        setAllDownloadItems(state) {
            document.querySelectorAll('#downloadSelection input[name="downloadFields[]"]').forEach((node) => {
                node.checked = state;
            });
            document.querySelector('#downloadSelection input[name="downloadFields[]"][value="Companynumber"]').checked = true;
        }

        setYearEndingIfFinancialFieldSelected() {
            console.log(this);
            if(this.data.financial_field) {
                document.querySelector('#downloadSelection input[name="downloadFields[]"][value="Yearending"]').checked = true;
            }
        }

        getFiltersForListDownload() {
            if (this.filterByCompanyNumberNameUrlOnly) {
                return this.getFiltersForCompaniesNumberNameUrlSearch();
            } else {
                return this.filters.getFiltersForSearch();
            }
        }

        prepareExploreListDownload() {
            // Request options
            let method, url, input, prepareExploreListDownloadSuccess, prepareExploreListDownloadError;
            const exploreListsObject = this;

            document.getElementById("downloadExploreListButton").disabled = true;
            document.getElementById("downloadListOverlay").classList.add("downloadInProgress");

            method = "POST";
            url = `../api/explore/explore_actions.php?action=preparedownload&listid=${this.activeExploreListID}`;

            let filename = 'TDC_Explore_';
            if (this.activeExploreListID) {
                filename += this.activeExploreListName.replace(/ /g, "_");
            }

            input = {
                ListName: filename,
                DownloadFormat: document.querySelector("#downloadExploreListForm input[name='downloadFormat']:checked").value,
                OrderBy: this.orderResultsBy,
                Order: this.orderResults,
                DownloadFields: Array.from(document.querySelectorAll('#downloadListOverlay input[name="downloadFields[]"]:checked'))
                .map((checkbox) => checkbox.value),
                DownloadFiles: Array.from(document.querySelectorAll('#downloadListOverlay input[name="downloadFiles[]"]:checked'))
                    .map((checkbox) => checkbox.value),
            }
            const filtersForSearch = this.filters.getFiltersForSearch();
            Object.assign(input, filtersForSearch);
            Object.assign(input, this.prefilterCode ? {'prefilterCode': this.prefilterCode} : false);

            document.getElementById('downloadSelection').classList.add('hidden');
            document.querySelector('#downloadListOverlay .overlayClose').classList.add('hidden');
            document.getElementById('downloadInProgress').classList.remove('hidden');

            // Success
            prepareExploreListDownloadSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                exploreListsObject.prepareExploreListDownloadComplete(response);
            }

            // Error
            prepareExploreListDownloadError = function () {
                const response = {
                    status: "error",
                    title: "Download",
                    message: "Sorry, could not process your Explore list download."
                }
                exploreListsObject.prepareExploreListDownloadComplete(response);

            }

            coreFunctions.xhrHelper(method, url, prepareExploreListDownloadSuccess, prepareExploreListDownloadError, JSON.stringify(input));

        }

        prepareExploreListDownloadComplete(response) {
            coreFunctions.checkForDebugMessages(response);
            document.getElementById('downloadInProgress').classList.add('hidden');
            document.getElementById('downloadSelection').classList.remove('hidden');
            document.querySelector('#downloadListOverlay .overlayClose').classList.remove('hidden');
            document.getElementById("downloadListOverlay").classList.remove("downloadInProgress");
            document.getElementById("downloadExploreListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("downloadExploreListButton"));

            if (response.status == "success") {
                this.downloadExploreList(response);
            } else {
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        downloadExploreList(response) {
            let filename, inputJSON, xhr, url;
            url = `../api/explore/explore_actions.php?action=download&listid=${this.activeExploreListID}`;

            if (this.activeExploreListID) {
                filename = `TDC_Explore_${this.activeExploreListName.replace(/ /g, "_")}${response.fileUrl.replace(/\/.*\//, "")}`;
            } else {
                filename = `TDC_Explore${response.fileUrl.replace(/\/.*\//, "")}`;
            }

            inputJSON = {
                file_url: response.fileUrl,
                listID: this.activeExploreListID,
                listTitle: this.activeExploreListName,
                matchCount: this.results.matchCount
            }

            xhr = new XMLHttpRequest();
            xhr.open('POST', url);
            xhr.responseType = 'blob';
            xhr.onload = function (e) {
                if (this.status == 200) {
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveBlob(this.response, filename);
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(this.response);
                        link.download = filename;
                        link.click();
                    }
                }
            }

            xhr.send(JSON.stringify(inputJSON));
        }

        loadListButtonClick() {
            this.getExploreLists();
            coreFunctions.showOverlay("loadlist");
        }

        setLoadExploreListDefault() {
            if (document.querySelector(`#savedListsSelect option[value='${this.activeExploreListID}']`)) {
                document.getElementById("savedListsSelect").value = this.activeExploreListID;
            }
        }

        preloadExploreList(listID) {
            this.activeExploreListID = parseInt(listID);
            this.loadExploreListSubmit();
            return this;
        }

        loadExploreListSubmit(form) {
            document.getElementById("loadListSubmitButton").disabled = true;
            const method = "POST";
            let input;
            if (form) {
                input = new FormData(form);
            } else {
                input = new FormData();
                input.append("listID", this.activeExploreListID);
            }

            const url = `../api/explore/explore_actions.php?action=loadlist&listid=${this.activeExploreListID}`;

            const loadExploreListSuccess = (response) => {
                const responseParsed = JSON.parse(response);
                this.loadExploreListComplete(responseParsed);
            }

            const loadExploreListError = () => {
                response = {
                    "status": "error",
                    "title": "Error",
                    "message": "Sorry, could not retrieve saved Explore list."
                }
                this.loadExploreListComplete(response);
            }

            coreFunctions.xhrHelper(method, url, loadExploreListSuccess, loadExploreListError, input);
        }

        loadExploreListComplete(response) {
            coreFunctions.hideOverlay(document.getElementById("loadListSubmitButton"));
            document.getElementById("loadListSubmitButton").disabled = false;
            if (response.status == "success") {
                this.processLoadedExploreList(response);
            } else {
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        processLoadedExploreList(response) {
            this.activeExploreListID = response.exploreList.listID;
            this.activeExploreListName = response.exploreList.listName;
            this.activeExploreListNotes = response.exploreList.notes;
            if (response.exploreList.companyResetLocked) {
                this.filters.companyFilters.companiesFilterLockOn();
            } else {
                this.filters.companyFilters.companiesFilterLockOff();
            }
            this.filters.resetAllFilters().processAllStoredFilters(JSON.parse(response.exploreList.filters));
            this.enableExploreListControls().filteringStarted().displaySavePlusExplanationControl().filterCompanies();
        }

        saveExploreListButtonClick() {
            document.querySelector("#saveExploreListForm input[name='listID']").value = this.activeExploreListID;
            document.querySelector("#saveExploreListForm input[name='companyFilterResetLocked']").checked = this.filters.companyFilters.companyFilterResetLocked;
            document.querySelector("#saveExploreListForm input[name='listName']").value = document.getElementById("saveExploreListTitle").dataset.existingname = (this.activeExploreListID) ? this.activeExploreListName : `My Explore list ${moment().format("D-MMM-Y")}`;
            coreFunctions.showOverlay("saveexplorelist");
        }

        saveExploreList(form) {
            let method, url, input;
            const exploreListsObject = this;

            // We load the explore lists in case the user has not triggered the loading of them yet.
            // If the have the method will early return, to prevent unneseccary requests.
            this.getExploreLists();

            method = "POST";
            input = new FormData(form);
            input.append("filters", JSON.stringify(this.filters.getFiltersForSavedList()));
            url = `../api/explore/explore_actions.php?action=savelist&listid=${this.activeExploreListID}`;

            document.getElementById("saveExploreListSubmitButton").disabled = true;

            const saveExploreListSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                exploreListsObject.saveExploreListComplete(responseParsed);
            }

            const saveExploreListError = function () {
                response = {
                    "status": "error",
                    "title": "Error",
                    "message": "Sorry, could not retrieve saved Explore list."
                }
                exploreListsObject.saveExploreListComplete(response);
            }

            coreFunctions.xhrHelper(method, url, saveExploreListSuccess, saveExploreListError, input);
        }

        saveExploreListComplete(response) {
            document.getElementById("saveExploreListSubmitButton").disabled = false;
            document.getElementById("savePlusExplanationControl").classList.remove("visible");
            if (response.status == "success") {
                this.saveExploreListSuccess(response);
            }
            coreFunctions.hideOverlay(document.getElementById("saveExploreListSubmitButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        saveExploreListSuccess(response) {
            let savedListID, savedListName, savedListNotes, updatedList;
            savedListID = response.listID;
            savedListName = response.listName;
            savedListNotes = response.notes;

            this.activeExploreListID = savedListID;
            this.activeExploreListName = savedListName;
            this.activeExploreListNotes = savedListNotes;

            // Allow list controls to be accessed
            this.enableExploreListControls();
            document.getElementById("loadListWarning").classList.add("hidden");
            document.getElementById("loadListForm").classList.remove("hidden");

            document.getElementById("exploreListName").innerHTML = this.activeExploreListName;
            if (response.newList === true) {
                this.newExploreList(savedListID, savedListName, savedListNotes, response.created, null);
            } else {
                if (updatedList = this.exploreLists.find(list => list.listID == savedListID)) {
                    updatedList.name = savedListName;
                }
            }

        }

        submitCompanyRticsReport(form) {
            const method = "POST";
            const formData = new FormData(form);
            const url = "../api/company/company_actions.php?action=report_company_rtics";
            const options = {
                responseType: "json"
            };
            const success = (response) => this.submitCompanyRticsReportOnLoad(form, response);
            const error = () => this.submitCompanyRticsReportOnLoad(form, {status: "error", inputErrors: {general: "Sorry, we could not submit your request at this time."}});
            coreFunctions.xhrHelper(method, url, success, error, formData, options, form);
        }

        submitCompanyRticsReportOnLoad(form, response) {
            let reportMismatchedRticControl;

            coreFunctions.refreshFormFieldErrors(form, response.inputErrors);
            if (response.status == "success") {
                if (reportMismatchedRticControl = document.querySelector(`.similarCompany[data-companynumber='${response.companyNumber}'] .reportMismatchedRticButton[data-list_type='${response.listType}']`)) {
                    reportMismatchedRticControl.classList.add("reported");
                }
                coreFunctions.showStatusMessage(`${response.listType == "rtic" ? "RTICs" : "CICs"} reported`, "Thank for submitting your report.");
                coreFunctions.hideOverlay(document.getElementById("reportMismatchedRticButton"));
            }
            return this;
        }

        submitSuggestedRtics(form) {
            let method, url, input;
            const mlListObject = this;

            method = "POST";
            input = new FormData(form);
            url =  `../api/company/company_actions.php?action=suggest_rtics&company_number=${input.get('companynumber')}`;

            document.getElementById("suggestRticButton").disabled = true;

            const suggestRticSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                mlListObject.suggestRticLoad(response);
            }

            const suggestRticError = function () {
                const response = {
                    status: "error",
                    title: "Submission error",
                    message: "Sorry, we could not submit your request at this time."
                }
                mlListObject.suggestRticLoad(response);
            }

            coreFunctions.xhrHelper(method, url, suggestRticSuccess, suggestRticError, input);
        }

        submitSuggestedCics(form) {
            let method, url, input;
            const mlListObject = this;

            method = "POST";
            input = new FormData(form);
            url =  `../api/company/company_actions.php?action=suggest_cics&company_number=${input.get('companynumber')}`;

            document.getElementById("suggestCicButton").disabled = true;

            const suggestCicSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                mlListObject.suggestCicLoad(response);
            }

            const suggestCicError = function () {
                const response = {
                    status: "error",
                    title: "Submission error",
                    message: "Sorry, we could not submit your request at this time."
                }
                mlListObject.suggestCicLoad(response);
            }

            coreFunctions.xhrHelper(method, url, suggestCicSuccess, suggestCicError, input);
        }

        suggestRticLoad(response) {
            let suggestRticControl;

            document.getElementById("suggestRticButton").disabled = false;
            if (response && response.status == "success") {
                if (suggestRticControl = document.querySelector(`.similarCompany[data-companynumber='${response.company_number}'] .suggestRticButton`)) {
                    suggestRticControl.classList.add("reported");
                }
            }
            coreFunctions.showStatusMessage(response.title, response.message);
            coreFunctions.hideOverlay(document.getElementById("suggestRticButton"));
            return this;
        }

        suggestCicLoad(response) {
            let suggestRticControl;

            document.getElementById("suggestCicButton").disabled = false;
            if (response && response.status == "success") {
                if (suggestRticControl = document.querySelector(`.similarCompany[data-companynumber='${response.company_number}'] .suggestCicButton`)) {
                    suggestRticControl.classList.add("reported");
                }
            }
            coreFunctions.showStatusMessage(response.title, response.message);
            coreFunctions.hideOverlay(document.getElementById("suggestCicButton"));
            return this;
        }
    }

    class ExploreListResults {
        constructor(parent) {
            this.parent = parent;
            this.matchCount = null;
            this.companies = [];
            this.companyUrlsVisited = [];
            this.pageNumber = 1;
            this.companiesPerPage = 100;
        }

        processResults(results) {
            const exploreListResultsObject = this;
            this.matchCount = results.matchcount;
            this.companies = [];
            results.companies.forEach(companyData => exploreListResultsObject.processCompanyDetails(companyData));
            return this;
        }

        processCompanyDetails(companyData) {
            const company = new Company(companyData, this);
            this.companies.push(company);
        }

        getAllCompanyUrls() {
            return [...new Set(this.companies.map(element => element.companyURL))];
        }

        addToCompanyUrlsVisited(url) {
            if (!this.companyUrlsVisited.includes(url)) {
                this.companyUrlsVisited.push(url);
                console.log(this);
                Array.from(document.querySelectorAll(`a[data-visited][href*='${url}']`)).forEach(element => element.dataset.visited = 1);
            }
        }

        addCompaniesToPage() {
            const exploreListResults = this;
            let similarCompaniesList, similarCompaniesFragment;
            similarCompaniesList = document.getElementById("similarCompaniesList");
            similarCompaniesFragment = document.createDocumentFragment();
            while (similarCompaniesList.firstChild) {
                similarCompaniesList.removeChild(similarCompaniesList.firstChild);
            }
            if (this.matchCount > 0) {
                // Add scoring field label
                document.getElementById("scoringFieldTitle").innerHTML = document.getElementById("sortByField").options[document.getElementById("sortByField").selectedIndex].dataset.label;
                document.getElementById("similarCompaniesStatusBarHolder").classList.remove("hidden");

                this.companies.forEach((company, index) => {
                    let position = (index + 1) + ((exploreListResults.pageNumber - 1) * exploreListResults.companiesPerPage);
                    similarCompaniesFragment.appendChild(company.createCompanyPageElement(position, exploreListResults.matchCount, exploreLists.orderResultsBy, userHasCicLists))
                });

                similarCompaniesList.appendChild(similarCompaniesFragment);
            } else {
                this.noMatchingCompanies();
            }
            return this;
        }

        noMatchingCompanies() {
            document.getElementById("similarCompaniesStatusBarHolder").classList.add("hidden");
            document.getElementById("similarCompaniesList").appendChild(coreFunctions.createElementHelper("p", {innerHTML: `<img class="warning" src="${urlPath}/images/warning.svg"> No companies match the currently active filters.`}));
            return this;
        }

        formatPageNumbers() {
            const exploreListsObject = this;
            let pageNumbersStructure, pageLinksHolder, totalElementsInPageNumberStructure, pageNumber;

            if (this.matchCount > 0) {
                pageLinksHolder = document.getElementById("pageLinksHolder");
                while (pageLinksHolder.firstChild) {
                    pageLinksHolder.removeChild(pageLinksHolder.firstChild);
                }

                pageNumbersStructure = this.getPageNumbersStructure();
                totalElementsInPageNumberStructure = pageNumbersStructure.length;
                for (var i = 0; i < totalElementsInPageNumberStructure; i++) {
                    pageNumber = pageNumbersStructure[i];
                    if (pageNumbersStructure[i - 1] && pageNumber != (pageNumbersStructure[i - 1] + 1)) {
                        pageLinksHolder.appendChild(coreFunctions.createElementHelper("span", { innerHTML: ". .", class: "pageLink" }));
                    }
                    pageLinksHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: pageNumber, class: `actionControl pageLink${(pageNumber == this.pageNumber) ? " selected" : ""}`, "data-pagenumber": pageNumber }, { click: function () { exploreListsObject.pageSelect(this) } }));

                }

                document.getElementById("pageSelectionContainer").classList.remove("hidden");
            } else {
                document.getElementById("pageSelectionContainer").classList.add("hidden");
            }

            return this;
        }

        pageSelect(element) {
            let pageNumber = Number(element.dataset.pagenumber);
            this.pageNumber = pageNumber;
            this.formatPageNumbers();
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            exploreLists.filteringStarted().filterCompanies();
            return this;
        }

        getPageNumbersStructure() {
            let pageNumber, totalPages, pageStructure;

            pageNumber = this.pageNumber;
            totalPages = Math.ceil(this.matchCount / this.companiesPerPage);

            if (totalPages <= 10) {
                pageStructure = [];
                for (var i = 0; i < totalPages; i++) {
                    pageStructure.push(i + 1);
                }
                return pageStructure;
            } else if (pageNumber < 4) {
                return [1, 2, 3, 4, totalPages];
            } else if (pageNumber >= (totalPages - 2)) {
                return [1, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
            } else {
                return [1, pageNumber - 2, pageNumber - 1, pageNumber, pageNumber + 1, pageNumber + 2, totalPages];
            }
        }

        shiftPage(change) {
            let pageNumber, pageSelectElement;
            pageNumber = this.pageNumber + change;
            if (pageSelectElement = document.querySelector(`.pageLink[data-pagenumber='${pageNumber}']`)) {
                this.pageSelect(pageSelectElement);
            }
        }

        goToPageChange(pageNumber) {
            if ((pageNumber * this.companiesPerPage) <= (this.matchCount + this.companiesPerPage)) {
                this.pageNumber = pageNumber;
                this.formatPageNumbers();
                this.pageSelect(document.querySelector(`.pageLink[data-pagenumber='${this.pageNumber}']`));
            }
        }
    }

    class ExploreList {
        constructor(listID, name, notes, created, edited) {
            this.listID = listID;
            this.name = name;
            this.notes = notes;
            this.created = created;
            this.edited = edited;
            this.filters = null;
            this.companyResetLocked = null;
        }

        addListElementToLoadExploreList() {
            document.getElementById("loadListWarning").classList.add("hidden");
            document.getElementById("loadListForm").classList.remove("hidden");

            document.getElementById("savedListsSelect").appendChild(coreFunctions.createElementHelper("option", { innerHTML: this.name, value: this.listID }));
            return this;
        }

        removeListElementFromLoadExploreList() {
            document.getElementById("savedListsSelect").removeChild(document.querySelector(`#savedListsSelect option[value='${this.listID}']`));

            if (document.getElementById("savedListsSelect").children.length == 0) {
                document.getElementById("loadListWarning").classList.remove("hidden");
                document.getElementById("loadListForm").classList.add("hidden");
            }
        }

        editExploreListLoad(response) {
            // Remove in progress class from button
            document.getElementById("editExploreListSubmitButton").disabled = false;

            this.name = response.listName;
            exploreLists.activeExploreListName = response.listName;
            document.getElementById("exploreListName").innerHTML = this.name;

            // Update title on load option with new text
            document.querySelector(`#savedListsSelect option[value='${this.listID}']`).innerHTML = this.name;

            // Hide form and display success message
            coreFunctions.hideOverlay(document.getElementById("editExploreListForm"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }
    }

    const exploreLists = new ExploreLists();
    const companyAlerts = new CompanyAlerts();

    return {
        pageBodyLoad: pageBodyLoad,
        exploreLists: exploreLists,
        clearSuggestedRticsDropdown: clearSuggestedRticsDropdown,
        clearSuggestedCicsDropdown: clearSuggestedCicsDropdown,
        suggestedRticsDropdown: suggestedRticsDropdown,
        userHasCicLists: userHasCicLists,
        companyAlerts: companyAlerts
    }

}();
